//#region src/stream/queue.ts
/**
* Minimal promise-based async queue bridging the OpenCode event
* subscription's callback-style notifications into the async-iterable world
* the stream translator consumes.
*/
var AsyncQueue = class {
	values = [];
	waiters = [];
	ended = false;
	error = void 0;
	failed = false;
	push(value) {
		if (this.ended || this.failed) return;
		const waiter = this.waiters.shift();
		if (waiter) waiter.resolve({
			value,
			done: false
		});
		else this.values.push(value);
	}
	/** Signal normal completion; pending and future reads resolve as done. */
	end() {
		if (this.ended || this.failed) return;
		this.ended = true;
		for (const waiter of this.waiters.splice(0)) waiter.resolve({
			value: void 0,
			done: true
		});
	}
	/** Signal failure; pending and future reads reject (after buffered values drain). */
	fail(error) {
		if (this.ended || this.failed) return;
		this.failed = true;
		this.error = error;
		for (const waiter of this.waiters.splice(0)) waiter.reject(error);
	}
	[Symbol.asyncIterator]() {
		return { next: () => {
			if (this.values.length > 0) return Promise.resolve({
				value: this.values.shift(),
				done: false
			});
			if (this.failed) return Promise.reject(this.error);
			if (this.ended) return Promise.resolve({
				value: void 0,
				done: true
			});
			return new Promise((resolve, reject) => {
				this.waiters.push({
					resolve,
					reject
				});
			});
		} };
	}
};
//#endregion
export { AsyncQueue };

//# sourceMappingURL=queue.js.map